// extracted by mini-css-extract-plugin
export default {"risk-center":"RiskCenter_risk-center__J0+QI","full-page-loader":"RiskCenter_full-page-loader__O+-zk"};